import { render, staticRenderFns } from "./setBirthdayPage.vue?vue&type=template&id=a8215388&scoped=true"
import script from "./setBirthdayPage.vue?vue&type=script&lang=js"
export * from "./setBirthdayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8215388",
  null
  
)

export default component.exports